import React, { useState } from "react";
import {
  TextField,
  PrimaryButton,
  Stack,
  Label,
  mergeStyleSets,
} from "@fluentui/react";
import useAxios from "axios-hooks";
import DetailsTable from "../../../Table/DetailsTable";
import { axiosInstance } from '../../../../api/config';
import FeatureSummary from "../../../Util/FeatureSummary";
import env from "../../../../env";
const { REACT_APP_API_BASE_URI } = env;


// Define styles using Fluent UI's mergeStyleSets
const styles = mergeStyleSets({
  formRow: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
  },
  label: {
    flex: "1 0 25%",
  },
  input: {
    flex: "1 0 75%",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  listContainer: {
    marginTop: "20px",
  },
});

const MemberCourseLookup = () => {
  // State variables for form fields
  const [memberId, setMemberId] = useState();

  // State variable for grid data
  const [gridData, setGridData] = useState([]);

  const [{ loading }, execute] = useAxios(
    {
      url: `2020-05-05/user/course-lookup/${memberId}`,
      method: "GET",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const handleSubmit = async () => {
    try {
      const response = await execute();
      setGridData(response.data); // Assuming the response is an array of objects
    } catch (err) {
      console.error("Error fetching member lookup data:", err);
    }
  };

  // Column definitions for DetailsList
  const columns = [
    { key: "memberid", name: "MemberID", fieldName: "memberId", minWidth: 80 },
    { key: "crsid", name: "crsid", fieldName: "crsId", minWidth: 60 },
    { key: "slug", name: "slug", fieldName: "slug", minWidth: 250 },
    { key: "isoldcourse", name: "isoldcourse", fieldName: "isOldCourse", minWidth: 80 },
    { key: "createdon", name: "createdon", fieldName: "createdOn", minWidth: 100 },
    { key: "completedon", name: "completedon", fieldName: "completedOn", minWidth: 100 },
    { key: "firstcompletedon", name: "firstcompletedon", fieldName: "firstCompletedOn", minWidth: 120 },
    { key: "archive", name: "archive", fieldName: "archive", minWidth: 100 },
    { key: "cobrandid", name: "CBID", fieldName: "coBrandId", minWidth: 80 },
    { key: "prescore", name: "prescore", fieldName: "preScore", minWidth: 80 },
    { key: "postscore", name: "postscore", fieldName: "postScore", minWidth: 80 },
    { key: "knowledgegain", name: "knowledgegain", fieldName: "knowledgeGain", minWidth: 100 },
  ];

  return (
    <div style={{padding: '0 0 0 20px'}}>
      <h3>Member Course Lookup</h3>
      <div  style={{width:400}}>
      <Stack tokens={{ childrenGap: 0 }}>
        <div className={styles.formRow}>
          <Label className={styles.label}>MemberId</Label>
          <TextField
            className={styles.input}
            value={memberId}
            onChange={(e, newValue) => setMemberId(newValue || "")}
          />
        </div>
        <div className={styles.buttonRow}>
          <PrimaryButton onClick={handleSubmit}>Lookup</PrimaryButton>
        </div>
      </Stack>
      </div>

      {gridData.length > 0 && <div className={styles.listContainer}>
      <h5>Courses</h5>
      <DetailsTable
        items={gridData}
        columns={columns}
        loading={loading}
        mainColumn={"actionItemTitle"}
        style={{
          position: "relative",
          height: "80vh",
          width: "80vw",
        }}
      />
      </div>}
      <FeatureSummary
          label="About Member Course Lookup"
          summary="Enter a member ID to look up their course history. The results will display all courses the member has enrolled in or completed, including creation dates, completion dates, scores, and knowledge gain."
      />
    </div>
  );
};

export default MemberCourseLookup;
